<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 2rem">
<!--    <el-tab-pane label="留学日历" name="first">-->
<!--      <div class="main_con">-->
<!--        <div style="text-align: left;">-->
<!--          <H5>代办日志</H5>-->
<!--          <el-divider></el-divider>-->
<!--        </div>-->
        <div class="Calendarselect">
          <el-date-picker
            v-model="monthValue"
            type="month"
            size="mini"
            @change="changeMonth"
            :clearable="false"
          ></el-date-picker>
        </div>
        <el-calendar v-model="value" style="text-align: center;">
          <template slot="dateCell" slot-scope="{date, data}">
            {{ data.day.split('-').slice(1).join('-') }}
            <div style="width:100%;" v-for="item in scheduleData" >
              <el-popover
                placement="top-start"
                :title="item.title"
                width="400"
                trigger="hover"
                >
                <div>
                  <p>{{getContent(item)}}</p>
                  <p>开课时间：{{item.start_time}}</p>
                  <p>结课时间：{{item.end_time}}</p>
                </div>
                <el-tag slot="reference" :type="getStatus(item)" v-if="item.calendar_time == data.day"  class="tag">
                  {{item.title}}
                </el-tag>
              </el-popover>

            </div>
          </template>
        </el-calendar>
<!--      </div>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="留学总览" name="second">-->
<!--      <overview_info v-if="view_info" :user_process_id="user_process_id" @closeView="closeView"></overview_info>-->
<!--      <div v-if="!view_info">-->
<!--        <div style="text-align: left;">-->
<!--          <H5>进度总览</H5>-->
<!--          <el-divider></el-divider>-->
<!--        </div>-->
<!--        <template>-->
<!--          <el-table-->
<!--            :data="tableData"-->
<!--            style="width: 100%">-->
<!--            <el-table-column prop="title" label="进度名称"  align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <p style="font-size: 14px;font-weight: 700;margin-bottom: 0">{{scope.row.title}}</p>-->
<!--                <p style="font-size: 12px">最后操作时间：<br/>{{scope.row.last_time}}</p>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="当前进度" align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-progress v-if="scope.row.comment_percentage==100" :percentage="scope.row.comment_percentage" status="success" ></el-progress>-->
<!--                <el-progress v-else :percentage="scope.row.comment_percentage"  ></el-progress>-->

<!--                <p style="font-size: 12px;margin-top: 0.3rem">截止日期：-->
<!--                  <span v-if="scope.row.plan_time">{{scope.row.plan_time}}</span>-->
<!--                  <span v-else>未设置</span>-->
<!--                </p>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="process_info_num"  label="代办个数" align="center" width="80"></el-table-column>-->
<!--            <el-table-column prop="status"  label="状态" align="center"  width="80">-->
<!--              <template slot-scope="scope">-->
<!--                <el-tag :key=tags[scope.row.status].name  :type=tags[scope.row.status].type >{{tags[scope.row.status].name}}</el-tag>-->
<!--              </template>-->
<!--            </el-table-column>-->

<!--            <el-table-column fixed="right" label="操作"  align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button @click="showInfo(scope.row)" type="text" size="small">查看</el-button>-->
<!--                <el-button type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--        </template>-->
<!--      </div>-->
<!--    </el-tab-pane>-->
  </el-tabs>
</template>
<script>

import { getCalendarAgentList} from "@/api/overview.js";
import overview_info from './overview_info.vue'


export default {
  components: {
    overview_info
  },
  data() {
    return {
      activeName: 'first',
      value: new Date(),
      scheduleData: [],
      tags: [
        { name: '未开启', type: 'info' },
        { name: '已完成', type: 'success' },
        { name: '进行中', type: 'danger' }
      ],
      // tableData: [{
      //   comment_percentage:75,
      //   status: 1,
      //   last_time:"2022-10-09 16:56:13",
      //   plan_time:"2022-10-31 00:00:00",
      //   date: '2016-05-02',
      //   title: "填表课"
      // }],
      view_info:false,
      user_process_id:'',
    };
  },
  computed: {
    monthValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.value = newValue
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getContent(data){
      let string = '';
      if(data.status==1){
        string = "课程状态：已开放"
      }
      if(data.status==2){
        string = "课程状态：已开课"
      }
      if(data.status==3){
        string = "课程状态：已结束"
      }
      if(data.status==4){
        string = "课程状态：异常"
      }
      return string
    },
    getStatus(data){
      let string = '';
      if(data.status==1){
        string = "danger"
      }
      if(data.status==2){
        string = "danger"
      }
      if(data.status==3){
        string = "info"
      }
      if(data.status==4){
        string = "info"
      }
      return string
    },

    edit(id){
      this.$emit('editUserProcessesInfos',id);
    },
    closeView(data){
      console.log('关闭页面')
      this.view_info = false
    },
    getList(){
      getCalendarAgentList().then(response => {
        this.scheduleData = response.data
        console.log('请求成功,内容：',response)
      })
    },
    //月下拉选框
    changeMonth(){
      this.value = new Date(this.monthValue);
    },
    handleClick(tab, event) {},
    showInfo(data){
      this.view_info = true
      this.user_process_id = data.id
    }

  }
};
</script>
<style>

.tag{
  margin-top: 0.3rem;
  color: #19d3ea;font-size: 12px;width: 100%;   /*一定要设置宽度，或者元素内含的百分比*/
  overflow:hidden; /*溢出的部分隐藏*/
  white-space: nowrap; /*文本不换行*/
  text-overflow:ellipsis;/*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
}
.el-calendar-table .el-calendar-day{
  min-height: 85px;
  height: 100%;
}
.el-button-group{
  display: none;
}
.Calendarselect{
  top: 30px;
  position: relative;
  text-align: right;
  padding-right: 16px;
}

/* 日历表格今天样式 */
/*.el-backtop,*/
/*.el-calendar-table td.is-today {*/
/*  color: #7000BD;*/
/*}*/
/*!* 除去日历表格的padding *!*/
/*.el-calendar-table .el-calendar-day {*/
/*  height: auto;*/
/*  padding: 0;*/
/*}*/
/*!* 日历表格鼠标滑动样式 *!*/
/*.el-calendar-table .el-calendar-day:hover {*/
/*  !*background-color: #F26C08 !important;*!*/
/*  color: red;*/
/*}*/
/*!* 日历表格选择日期样式 *!*/
/*.el-calendar-table td.is-selected {*/
/*  background-color: #7000BD;*/
/*  color: white;*/
/*}*/



</style>



// WEBPACK FOOTER //
// src/components/mycenter/component/overview.vue